import { Ref } from 'vue';
import { FormKitNode, FormKitFrameworkContext } from '@formkit/core';
import { getValidationMessages } from '@formkit/validation';

export const useFormKit = () => {
  // https://formkit.com/essentials/architecture#using-a-template-ref
  const getContext = (ref: Ref<{ node?: FormKitNode } | null>): FormKitFrameworkContext | undefined => {
    const node = ref?.value?.node;
    if (!node) {
      return undefined;
    }
    return node.context;
  };

  const isValidRef = (ref: Ref<{ node?: FormKitNode } | undefined | null>) => {
    const node = ref.value?.node;
    if (!node) {
      return false;
    }
    const validations = getValidationMessages(node);
    return validations.size === 0;
  };

  return { getContext, isValidRef };
};
